import { h, ComponentChildren, createRef, Component } from "preact";

import classname from "../../../foundation/utils/classname";
import { stopPropagation } from "../../../foundation/utils/legacy";
import { imageUrl } from "../../../foundation/utils/image";

import styles from "./DropdownItem.module.css";

interface Props {
    label: string | JSX.Element;
    selected: boolean;
    class?: string;
    children?: ComponentChildren;
    onHover?: (parentItem: DropdownParentItem) => void;
}

export default class DropdownParentItem extends Component<Props> {
    ref = createRef<HTMLDivElement>();

    handleMouseEnter = () => {
        const { onHover } = this.props;
        onHover!(this);
    };

    render() {
        const { class: cssClass, label, selected } = this.props;
        const classes = classname(styles.dropdownItem, "noSelect", cssClass, { selected });

        return (
            <div
                class={classes}
                ref={this.ref}
                onClick={stopPropagation}
                onMouseEnter={this.handleMouseEnter}>
                <div class={classname(styles.dropdownItemContent, "ellipsis")}>
                    {label}
                </div>
                <img src={imageUrl("img/icMenuArrow.svg")} alt="&gt;" class="dropdownChevron"/>
            </div>
        );
    }
}
